import * as yup from 'yup';
import Base from './Base';

const baseSchema = yup.object().shape({
  confirmPassword: yup.string().required('Confirm password is required'),
  dateOfBirth: yup.date().required('Date of birth is required'),
  email: yup.string().email('Invalid email format').required('Email is required'),
  gender: yup.string().oneOf(['female', 'male', 'other'], 'Invalid gender').required('Gender is required'),
  name: yup.string().required('Name is required'),
  password: yup.string().required('Password is required'),
  phoneNumber: yup.string().required('Phone number is required'),
  preferredName: yup.string().required('Preferred name is required'),
  role: yup.string().oneOf(['admin', 'creator', 'lead-tech', 'radiologist', 'technologist', 'trainee', 'user'], 'Invalid role'),
});

const facilitySchema = yup.object().shape({
  departmentId: yup.number().required('Department is required'),
  facilityId: yup.number().required('Facility is required'),
});

const modalitySchema = yup.object().shape({
  modality: yup.string().required('Modality is required'),
});

export default class User extends Base {
  static validateCreate(item, fields) {
    let createSchema = baseSchema;

    if (item && item.role === 'technologist') {
      createSchema = baseSchema.concat(modalitySchema);
    }

    return super.validate(item, fields, createSchema);
  }

  static validateUpdate(item, fields) {
    // Create update schema without password requirement
    const updateFields = { ...baseSchema.fields };
    delete updateFields.password;
    let updateSchema = yup.object().shape(updateFields);

    const needsFacilityValidation = fields.some((field) => ['facilityId', 'departmentId'].includes(field));
    const needsModalityValidation = fields.some((field) => ['modality'].includes(field));

    if (needsFacilityValidation) {
      updateSchema = updateSchema.concat(facilitySchema);
    }

    if (needsModalityValidation) {
      updateSchema = updateSchema.concat(modalitySchema);
    }

    return super.validate(item, fields, updateSchema);
  }

  createdAt = new Date();
  id = null;
  role = '';
  updatedAt = new Date();
  name = '';
  preferredName = '';
  phoneNumber = '';
  email = '';
  gender = null;
  password = '';
  confirmPassword = '';
  dateOfBirth = null;
  workspaceId = 0;
  facilityId = null;
  departmentId = null;
  modality = null;
  modalities = [];
  fullTimeEmployment = 1;

  constructor(props) {
    super();
    this.clone(props);
    this.dateOfBirth = this.dateOfBirth ? new Date(this.dateOfBirth) : null;
    this.createdAt = this.createdAt ? new Date(this.createdAt) : null;
    this.updatedAt = this.updatedAt ? new Date(this.updatedAt) : null;
  }
}
